import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { ConfirmationService } from 'primeng/api';
import { ToastService } from '../../../../../services/toast.service';
import { ContratoTMA } from '../../../../../types/ContratoTMA.type';
import {ContratoService} from "../../../../../services/contrato.service";


@Component({
  selector: 'app-tmalist',
  templateUrl: './tmalist.component.html',
  styleUrl: './tmalist.component.css',
  providers: [ConfirmationService]
})

export class TmalistComponent {
loading: boolean = false;
  taxas: ContratoTMA[] = []

  taxaSelecionada: ContratoTMA = {} as ContratoTMA

  visivel: boolean = false

  constructor(private contratoService: ContratoService, private router: Router,
              private toastService: ToastService, private confirmationService: ConfirmationService) {}

  ngOnInit(){
    this.carregarTaxas();
  }

  carregarTaxas(){
    this.loading = true;
    this.taxas = [];
    this.contratoService.getTmas().subscribe({
      next: (data) => {
        this.taxas = data



      },
      error: (error) => {
        this.loading = false;
        this.toastService.erro("Erro", error.error.message);
      },
      complete: () => {
        this.loading = false;
      }
    })
  }

  abreTmaDialog(taxa: ContratoTMA){
      this.visivel = true

      this.taxaSelecionada = taxa;
    }

  escondeTmaDialog(){
     this.visivel = false
     this.taxaSelecionada = {} as ContratoTMA

     this.carregarTaxas()
    }

  excluir(id: string){
    this.contratoService.deleteTma(id).subscribe({
      next: () => {
        this.toastService.sucesso("Sucesso", "Provisão excluída com sucesso");
        this.carregarTaxas();
      },
      error: (value) => {
       this.toastService.erro("Erro", "Erro ao excluir: " + value)
      }
    })
  }

  confirmarExclusao(id: string) {
    this.confirmationService.confirm({
      message: 'Tem certeza de que deseja excluir ?',
      header: 'Confirmar',
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.excluir(id);
      }
      });
  }
}
